"use strict";
exports.__esModule = true;
exports.STATIC_ASSETS_URL = void 0;
exports.STATIC_ASSETS_URL = process.env.NODE_ENV !== 'production'
    ? 'https://dev.epilot.cloud/elements-static'
    : 'https://go.epilot.cloud/elements-static';
//# sourceMappingURL=config.js.map